import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { SiteLogo } from "./SiteLogo";
import { LangSwitcher } from "./LangSwitcher";

export default function Footer() {
  const [pages, setPages] = useState([]);
  const [cfg, setCfg] = useState({});
  useEffect(() => {
    api.get("/site/footer").then(({ data }) => { setPages(data.pages || []); setCfg(data.config || {}); }).catch(() => {});
  }, []);

  const legal = [cfg.razao_social, cfg.cnpj && `CNPJ ${cfg.cnpj}`, cfg.endereco].filter(Boolean).join(" · ");

  return (
    <footer className="border-t border-border/60 bg-card/40 mt-auto" data-testid="site-footer">
      <div className="max-w-6xl mx-auto px-6 py-10 flex flex-col md:flex-row md:items-start md:justify-between gap-6">
        <div className="flex flex-col gap-3">
          <SiteLogo className="h-7 w-auto" />
          {cfg.contato_email && <a href={`mailto:${cfg.contato_email}`} className="text-xs text-muted-foreground hover:text-foreground w-fit" data-testid="footer-email">{cfg.contato_email}</a>}
        </div>
        {pages.length > 0 && (
          <nav className="flex flex-wrap gap-x-5 gap-y-2" data-testid="footer-pages">
            {pages.map((p) => (
              <a key={p.slug} href={`/${p.slug}`} className="text-sm text-muted-foreground hover:text-foreground transition-colors" data-testid={`footer-page-${p.slug}`}>{p.titulo}</a>
            ))}
          </nav>
        )}
        <div className="text-xs text-muted-foreground md:text-right md:max-w-xs">
          <LangSwitcher className="mb-3" />
          <div>© {new Date().getFullYear()} {cfg.empresa || "LiveGrafX"}</div>
          {legal && <div className="mt-1 opacity-70" data-testid="footer-legal">{legal}</div>}
        </div>
      </div>
    </footer>
  );
}
